import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterOutlet],
})
export class PublicComponent implements OnInit {
  constructor(private router: Router) { }

  ngOnInit(): void {
    // if auth guard fails --> will stay at /public
    this.router.navigate(['/secure']);
  }
}
